import classes from "./LoadingCreationModal.module.css";

export const LoadingCreationModal = ({ studioImage, fromServiceCreation }) => {

  return (
    <div className={classes.blocker}>
        <div className={classes.container}>
            <header className={classes.header}>
                <h1 className="titleSemibold">{fromServiceCreation ? "Dein Service ist gleich online✨" : "Dein Studio ist gleich online✨"}</h1>
                <span className="regularSmall">Seite bitte nicht schließen.</span>
            </header>
            <div className={classes.main}>
                <div className={classes.loaderWrapper}>
                    <div className={classes.tubeOuter}>
                        <svg
                            className={classes.tubeFlow}
                            viewBox="0 0 100 100"
                            preserveAspectRatio="none"
                        >
                            <rect
                                className={classes.tubeFlowTrack}
                                x="0"
                                y="0"
                                width="100%"
                                height="100%"
                                rx="10"
                                ry="10"
                                pathLength="1"
                            />
                        </svg>
                        <div className={classes.studioImageWrapper}>
                            <img src={studioImage} alt="Studio" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
};

export default LoadingCreationModal;